module.exports = __webpack_public_path__ + "img/ic-server-error.1f1e2f4d.png";